<template>
  <SelectContianer
    v-on:closeSelectContainer="close"
    :showChildSelect="showChildSelect"
    :hiddenHeader="true"
  >
    <template slot="select-content">
      <ul class="card-select-container j-card-select-container">
        <li
          class="select-items-popup"
          :class="{ active: item.value == curType }"
          pointClass="j-select-card"
          @click="selectType(item.value)"
          v-for="item in searchType"
          :key="item.value"
        >
          {{ item.name }}
        </li>
      </ul>
    </template>
  </SelectContianer>
</template>
<script>
import selectContainer from '@mixins/officialWebStore/selectContainer';
export default {
  name: 'SeatchTypeSelecter',
  mixins: [selectContainer],
  props: ['searchType', 'curType'],
  methods: {
    selectType(type) {
      this.$emit('selectType', type);
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/_dimen.scss';
.select-header-inner {
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.select-items-popup {
  display: flex;
  justify-content: space-between;
  font-size: 26px;
}
</style>
